export default "__VITE_ASSET__CFIdIpMf__"